import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6 flex flex-wrap items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-forest-deep/45" data-testid="breadcrumbs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const testid = item.label === "Home" ? "breadcrumb-home" : isLast ? "breadcrumb-current" : "breadcrumb-parent";
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {index > 0 && <ChevronRight className="h-3.5 w-3.5 text-forest-deep/25" />}
            {item.href && !isLast ? (
              <Link to={item.href} className="transition-colors hover:text-forest-primary" data-testid={testid}>{item.label}</Link>
            ) : (
              <span className={isLast ? "text-forest-primary" : ""} data-testid={testid}>{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
